import {IRootState} from "../reducers";

export const getToastOptions = (state: IRootState) =>
  state.toastReducer.toastOptions;
